import { render, staticRenderFns } from "./RaceStatistics.vue?vue&type=template&id=6b6a2a28&scoped=true"
import script from "./RaceStatistics.vue?vue&type=script&lang=js"
export * from "./RaceStatistics.vue?vue&type=script&lang=js"
import style0 from "./RaceStatistics.vue?vue&type=style&index=0&id=6b6a2a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a2a28",
  null
  
)

export default component.exports